exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dialogue-question {\n  margin: 16px 10px 0px 10px;\n  text-align: center;\n  color: #484848;\n  font-size: 18px; }\n\n.year-range-botton-cont {\n  padding: 16px 0px; }\n\n.year-dialog-content {\n  max-width: 250px !important; }\n\n.year-dialogue-button {\n  float: right; }\n\n.year-dialogue-button div {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/YearDialogue/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/YearDialogue/index.css
// module chunks = 504